/**
 * GraphQL Query
 * 保留条件指定商品一覧画面
 */

/**
 * 保留条件指定商品一覧
 */
export const GRAPH_QL_QUERY_PENDING_PRODUCT_LIST =
`
query {
  pendingProductList( ? ) {
    edges {
      node {
        id
        uuid
        site {
          code
          name
        }
        status
        name
        startedAt
        endedAt
        note
        pendingProductListItems {
          productId
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
    totalCount
  }
}
`
